module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5a87ad00dba29bece77449d9e118f7b3.png";